module.exports = __webpack_public_path__ + "static/media/aisico.03ea2d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/aisico.png
// module id = 117
// module chunks = 0